'use strict';

var getDpresultsRoute = require('../handlers/dpresults/navigation');

const mainUrl = 'https://' + location.hostname + '/travel/';

module.exports = {
    getPath: function(targetPage, queryString, stringifyParams) {
        var targetApp = Odigeo.Router.getApp(targetPage);
        return mainUrl + ('home' === targetApp ? '' : targetApp + '/') +
            (queryString || '') + '#' + targetPage + '/' + (stringifyParams || '');
    },
    getResultsPagePath: function(queryString, params) {
        return this.getPath('results', queryString, (!_.isUndefined(params) ?
            (!_.isString(params) ? App.Flights.searchParamsStringify(params) : params)
            : ''));
    },
    getPostBookingPath: function() {
        return `${mainUrl}secure/#/post_booking/`;
    },
    getDPResultsPagePath: function(queryString, params) {
        return this.getPath(getDpresultsRoute(), queryString, (!_.isUndefined(params) ?
            (!_.isString(params) ? App.Dynpack.searchParamsStringify(params) : params)
            : ''));
    },
    getCheckInPath: function() {
        return this.getPath('mytripslogin', null, 'actions=opencmf');
    },
    getSupportAreaHomePagePath: function() {
        return `${mainUrl}support-area/`;
    },
    getSupportAreaLoginPath: function() {
        return this.getPath('mytripslogin', null, 'actions=opensa');
    },
    getMyTripsPath: function() {
        return `${mainUrl}membership-pages/#membership_mytrips_reactivation/`;
    },
    getMyTripsLoginPath: function() {
        return this.getPath('mytripslogin');
    },
    getLoginPath: function() {
        return this.getPath('home');
    },
    getRegisterPath: function() {
        return this.getPath('register');
    },
    getFrequentPassengersPath: function() {
        return this.getPath('frequentpassengers');
    },
    getAccountCreditCardsPath: function() {
        return this.getPath('accountcreditcards');
    },
    getAccountPreferencesPath: function() {
        return this.getPath('accountpreferences');
    },
    getHomePath: function() {
        return this.getPath('home');
    },
};
